import { APP_CONSTANTS } from '@/config/constants';
import { getLogger } from '@/utils/logger';
import type { AppleIapProduct, AppleIapPurchaseResult } from './appleIapTypes';

export type { AppleIapProduct, AppleIapPurchaseResult } from './appleIapTypes';

const logger = getLogger('APPLE-IAP-SERVICE');

const unavailableError = () =>
  new Error('Assinaturas Apple estao disponiveis apenas na build iOS configurada.');

export const getConfiguredAppleIapProductIds = (): string[] =>
  APP_CONSTANTS.APPLE_IAP.PLANS.map((plan) => plan.productId).filter(Boolean);

export const isAppleIapRuntimeAvailable = (): boolean => false;

export const isAppleIapCancellationError = (_error: unknown): boolean => false;

export const getAppleIapProducts = async (): Promise<AppleIapProduct[]> => {
  logger.info('[APPLE-IAP] Catalogo nativo ignorado fora do iOS');
  return [];
};

export const subscribeWithAppleIap = async (
  _productId: string,
  _empresaId: string,
): Promise<AppleIapPurchaseResult> => {
  throw unavailableError();
};

export const restoreAppleIapPurchases = async (
  _empresaId: string,
): Promise<AppleIapPurchaseResult[]> => {
  throw unavailableError();
};

export default {
  getAppleIapProducts,
  getConfiguredAppleIapProductIds,
  isAppleIapRuntimeAvailable,
  restoreAppleIapPurchases,
  subscribeWithAppleIap,
};
